/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Belief_Body_1Inputs */

const en_about_belief_body_1 = /** @type {(inputs: About_Belief_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A reply with the right context. A report with the sources attached. A handoff that reaches the next person with everything they need.`)
};

const lv_about_belief_body_1 = /** @type {(inputs: About_Belief_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilde ar pareizo kontekstu. Atskaite ar pievienotiem avotiem. Darbs, kas nonāk pie nākamā cilvēka kopā ar visu tam nepieciešamo informāciju.`)
};

/**
* | output |
* | --- |
* | "A reply with the right context. A report with the sources attached. A handoff that reaches the next person with everything they need." |
*
* @param {About_Belief_Body_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_belief_body_1 = /** @type {((inputs?: About_Belief_Body_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Belief_Body_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_belief_body_1(inputs)
	return en_about_belief_body_1(inputs)
});